const firebaseConfig = {
  apiKey: "AIzaSyA-GXiJl5wSXw8lg_EwDDIo5kLdAiVVzpA",
  authDomain: "medicare-health-services.firebaseapp.com",
  projectId: "medicare-health-services",
  storageBucket: "medicare-health-services.appspot.com",
  messagingSenderId: "406029415891",
  appId: "1:406029415891:web:7ac4682a25a2767308ab26",
  measurementId: "G-0TLKH0RBBY"
};
export default firebaseConfig;